import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import visitArticleAction from "cc-frontend/lib/actions/app-state/KB_VISIT_ARTICLE"
import _ from "lodash"

export default class ArticleRoute extends Route {
  @service("ember-store")
  store

  @service("dispatcher")
  dispatcher

  model(params) {
    let id = _.last(_.split(params.article_id, "-"))
    return get(this, "store").find("kb-entry", id)
  }

  afterModel(model, transition) {
    if (model) {
      const displayedArticleId = _.kebabCase(model.attributes.title) + "-" + model.id
      if (this.paramsFor(this.routeName).article_id !== displayedArticleId) {
        this.transitionTo("help.article", displayedArticleId)
        return
      }

      this.dispatcher.dispatchPreparedAction(
        visitArticleAction({
          articleId: model.id,
          articleTitle: model.attributes.title,
        })
      )
    }
    if (window && window.document) {
      $(window).scrollTop(0)
    }
  }
}
